import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "passcode/";

class PasscodeService {
  delete(bookingId, passcodeId) {
    return axios.delete(ENDPOINT_URL + "b/" + bookingId + "/" + passcodeId, {
      headers: authHeader(),
    });
  }

  getFromLock(passcodeId) {
    return axios.get(ENDPOINT_URL + passcodeId, {
      headers: authHeader(),
    });
  }

  current() {
    return axios.get(ENDPOINT_URL + "current", {
      headers: authHeader(),
    });
  }

  getMasterPasscodes() {
    return axios.get(ENDPOINT_URL + "master/list", {
      headers: authHeader(),
    });
  }

  setMasterPasscode(code, name, doorIds) {
    return axios.post(
      ENDPOINT_URL + "master",
      { code, name, doorIds },
      { headers: authHeader() },
    );
  }

  deleteMasterPasscode(passcode, doorIds) {
    return axios.delete(ENDPOINT_URL + "master/" + passcode, {
      ...(doorIds ? { data: { doorIds } } : {}),
      headers: authHeader(),
    });
  }

  syncMasterPasscodes() {
    return axios.get(ENDPOINT_URL + "master/sync", {
      headers: authHeader(),
    });
  }

  getDoorPasscodes(doorId) {
    return axios.get(ENDPOINT_URL + "door/" + doorId, {
      headers: authHeader(),
    });
  }

  createDoorPasscode(doorId, data) {
    return axios.post(ENDPOINT_URL + "door/" + doorId, data, {
      headers: authHeader(),
    });
  }

  deleteDoorPasscode(doorId, passcodeId) {
    return axios.delete(ENDPOINT_URL + "door/" + doorId + "/" + passcodeId, {
      headers: authHeader(),
    });
  }
}

export default new PasscodeService();
